import React from 'react';

import { JsonLD, withConfig } from '../common/Block.jsx';
import { Container } from '../common/Container.jsx';
import { Tab, TabsContainer } from '../common/Tab.jsx';

import { Legacy as ArtistBio } from './ArtistBio.jsx';
import { InventoryListV1 } from './InventoryList.jsx';

class _ArtistTabbed extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tab: 'Artworks'
        }

        this.tabs = { art: 'Artworks', bio: 'Biography' };
    }

    render() {
        const handleTabClick = (tab) => this.setState({ tab: tab });
        const bio = this.props.data.bio || {};
        const inventory = this.props.data.inventory || {};
        return (
            <React.Fragment>
                <Container className="bio__cont">
                    <div className="bio__head">
                        <h1 className="bio__name">{bio.name}</h1>
                        <TabsContainer builder={this.props.builder} className="bio__controls">
                            <Tab active={this.state.tab == this.tabs.art} display="Artwork" value={this.tabs.art} onClick={handleTabClick} />
                            <Tab active={this.state.tab == this.tabs.bio} display="Biography" value={this.tabs.bio} onClick={handleTabClick} />
                        </TabsContainer>
                    </div>
                    <ContentWrapper active={this.state.tab == this.tabs.art}>
                        <InventoryListV1.Component
                            blockConfig={inventory.config}
                            builder={this.props.builder}
                            config={this.props.config}
                            context={inventory.context}
                            data={inventory.data}
                            legacy={true}
                            querySub={this.props.querySub} />
                    </ContentWrapper>
                    <ContentWrapper active={this.state.tab == this.tabs.bio}>
                        <ArtistBio.Component
                            blockConfig={bio.config}
                            builder={this.props.builder}
                            config={this.props.config}
                            data={bio}
                            legacy={true} />
                    </ContentWrapper>
                </Container>
                <JsonLD
                    baseUrl={this.props.baseUrl}
                    builder={this.props.builder}
                    jsonLD={inventory.jsonLD}
                    path="art"
                    querySub={this.props.querySub} />
            </React.Fragment>
        );
    }
}
const ArtistTabbed = withConfig(_ArtistTabbed);

function ContentWrapper(props) {
    let className = 'tabs__content tabs__content--artist';
    if (props.active) {
        className += ' current';
    }
    return (
        <div className={className}>
            {props.children}
        </div>
    )
}

export default ArtistTabbed;